<template>
    <div>
        <ul class="nav nav-pills" role="tablist">
            <li class="nav-item" role="presentation">
                <a :class="['nav-link', active_tab === 'saderat' ? 'active' : '']"
                   @click="setTab('saderat')"
                   href="#"
                   id="saderat-tab"
                   role="tab"
                >
                    <span v-text="$t('wallets.bank.saderat')"></span>
                </a>
            </li>
            <li class="nav-item" role="presentation">
                <a :class="['nav-link', active_tab === 'keshavarzi' ? 'active' : '']"
                   @click="setTab('keshavarzi')"
                   href="#"
                   id="keshavarzi-tab"
                   role="tab"
                >
                    <span v-text="$t('wallets.bank.keshavarzi')"></span>
                </a>
            </li>
            <li class="nav-item" role="presentation">
                <a :class="['nav-link', active_tab === 'ayande' ? 'active' : '']"
                   @click="setTab('ayande')"
                   href="#"
                   id="ayande-tab"
                   role="tab"
                >
                    <span v-text="$t('wallets.bank.ayande')"></span>
                </a>
            </li>
            <li class="nav-item" role="presentation">
                <a :class="['nav-link', active_tab === 'saman' ? 'active' : '']"
                   @click="setTab('saman')"
                   href="#"
                   id="saman-tab"
                   role="tab"
                >
                    <span v-text="$t('wallets.bank.saman')"></span>
                </a>
            </li>
            <li class="nav-item" role="presentation">
                <a :class="['nav-link', active_tab === 'parsian' ? 'active' : '']"
                   @click="setTab('parsian')"
                   href="#"
                   id="parsian-tab"
                   role="tab"
                >
                    <span v-text="$t('wallets.bank.parsian')"></span>
                </a>
            </li>
            <li class="nav-item" role="presentation">
                <a :class="['nav-link', active_tab === 'pasargad' ? 'active' : '']"
                   @click="setTab('pasargad')"
                   href="#"
                   id="pasargad-tab"
                   role="tab"
                >
                    <span v-text="$t('wallets.bank.pasargad')"></span>
                </a>
            </li>
            <li class="nav-item" role="presentation">
                <a :class="['nav-link', active_tab === 'melli' ? 'active' : '']"
                   @click="setTab('melli')"
                   href="#"
                   id="pasargad-tab"
                   role="tab"
                >
                    <span v-text="$t('wallets.bank.melli')"></span>
                </a>
            </li>
            <li class="nav-item" role="presentation">
                <a :class="['nav-link', active_tab === 'tejarat' ? 'active' : '']"
                   @click="setTab('tejarat')"
                   href="#"
                   id="pasargad-tab"
                   role="tab"
                >
                    <span v-text="$t('wallets.bank.tejarat')"></span>
                </a>
            </li>
            <li class="nav-item" role="presentation">
                <a :class="['nav-link', active_tab === 'mellat' ? 'active' : '']"
                   @click="setTab('mellat')"
                   href="#"
                   id="mellat-tab"
                   role="tab"
                >
                    <span v-text="$t('wallets.bank.mellat')"></span>
                </a>
            </li>
        </ul>
        <div class="tab-content">
            <div class="tab-pane fade show active"
                 id="saderat"
                 role="tabpanel"
                 v-if="active_tab === 'saderat'">
                <saderat :api_base_path="api_base_path" :key="container"  :fetch_starshop="fetch_starshop"></saderat>
            </div>
            <div class="tab-pane fade show active"
                 id="keshavarzi"
                 role="tabpanel"
                 v-if="active_tab === 'keshavarzi'">
                <keshavarzi :api_base_path="api_base_path" :key="container"  :fetch_starshop="fetch_starshop"></keshavarzi>
            </div>
            <div class="tab-pane fade show active"
                 id="ayande"
                 role="tabpanel"
                 v-if="active_tab === 'ayande'">
                <ayande :api_base_path="api_base_path" :key="container" :fetch_starshop="fetch_starshop"></ayande>
            </div>
            <div class="tab-pane fade show active"
                 id="saman"
                 role="tabpanel"
                 v-if="active_tab === 'saman'">
                <saman :api_base_path="api_base_path" :key="container" :fetch_starshop="fetch_starshop"></saman>
            </div>
            <div class="tab-pane fade show active"
                 id="parsian"
                 role="tabpanel"
                 v-if="active_tab === 'parsian'">
                <parsian :api_base_path="api_base_path" :key="container" :fetch_starshop="fetch_starshop"></parsian>
            </div>
            <div class="tab-pane fade show active"
                 id="pasargad"
                 role="tabpanel"
                 v-if="active_tab === 'pasargad'">
                <pasargad :api_base_path="api_base_path" :key="container" :fetch_starshop="fetch_starshop"></pasargad>
            </div>
            <div class="tab-pane fade show active"
                 id="pasargad"
                 role="tabpanel"
                 v-if="active_tab === 'melli'">
                <melli :api_base_path="api_base_path" :key="container" :fetch_starshop="fetch_starshop"></melli>
            </div>
            <div class="tab-pane fade show active"
                 id="pasargad"
                 role="tabpanel"
                 v-if="active_tab === 'tejarat'">
                <tejarat :api_base_path="api_base_path" :key="container" :fetch_starshop="fetch_starshop"></tejarat>
            </div>
            <div class="tab-pane fade show active"
                 id="mellat"
                 role="tabpanel"
                 v-if="active_tab === 'mellat'">
                <mellat :api_base_path="api_base_path" :key="container" :fetch_starshop="fetch_starshop"></mellat>
            </div>
        </div>
    </div>
</template>

<script>
    import saderat from './statements/saderat'
    import keshavarzi from './statements/keshavarzi'
    import ayande from './statements/ayande'
    import saman from './statements/saman'
    import Parsian from "./statements/parsian.vue";
    import Pasargad from "./statements/pasargad.vue";
    import Tejarat from "./statements/tejarat.vue";
    import Melli from "@/views/wallets/AyandeWallets/Admin/components/statements/melli.vue";
    import Mellat from "@/views/wallets/AyandeWallets/Admin/components/statements/mellat.vue";
    import {ApiUrl} from "@/common/api.service";
    import SettlementList from "@/views/wallets/AyandeWallets/Admin/components/settlement-list.vue";

    export default {
        components: {
            SettlementList,
            Melli,
            Mellat,
            Pasargad,
            Parsian,
            saderat,
            keshavarzi,
            ayande,
            saman,
            Tejarat,
        },
        props: {
            fetch_starshop: {
                default: false,
                type: Boolean
            },
            api_base_path: {
                default: ApiUrl.path(''),
                type: String
            },
            container: {
                default: 0,
                type: Number
            }
        },
        data() {
            return {
                active_tab: 'saderat',
            };
        },
        mounted() {},
        methods: {
            setTab(tab) {
                this.active_tab = tab;
            },
        },
    }
</script>
